<template>
  <div class="rule" :class="cssType">
    <div class="rule-title" :class="locale"></div>
    <div class="rule-content" :class="locale">
      <div class="rule-content-title">
        {{ t('accumRecharge.rule.title') }}
      </div>
      <div class="rule-content-part" v-for="text in ruleTexts" :key="text">
        <span v-html="text"></span>
        <br />
      </div>
    </div>
  </div>
</template>
<script setup>
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
const { locale, t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const payUrl = computed(() => {
  return process.env.VUE_APP_HISTORY_URL + locale.value
})
const ruleTexts = computed(() => {
  const text = t('accumRecharge.rule.content')
  const texts = text.split('\n')
  const textList = texts.map(text => {
    if (text.includes('[goRecharge]')) {
      text = text.replace('[goRecharge]', `
      <a href="${payUrl.value}" class="act-link" target="_blank">
        [${t('accumRecharge.goRecharge')}]
      </a>
      `)
    }
    return text
  })
  return textList
})
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>